import { onUnmounted, type Ref, ref } from 'vue';

export type Poller = {
  startPolling: () => void;
  stopPolling: () => void;
  pollingEnabled: Ref<boolean>;
};

export default function usePolling(
  pollFn: () => void | Promise<unknown>,
  interval: number,
): Poller {
  const timeToMakeNextRequest = ref(0);
  const animationFrameId = ref(-1);
  const pollingEnabled = ref(false);

  async function rafTimer(time: number) {
    if (timeToMakeNextRequest.value <= time) {
      await pollFn();
      timeToMakeNextRequest.value = time + interval;
    }

    if (pollingEnabled.value) {
      animationFrameId.value = requestAnimationFrame(rafTimer);
    }
  }

  function startPolling() {
    pollingEnabled.value = true;
    animationFrameId.value = requestAnimationFrame(rafTimer);
  }

  function stopPolling() {
    pollingEnabled.value = false;
    cancelAnimationFrame(animationFrameId.value);
    timeToMakeNextRequest.value = 0;
  }

  onUnmounted(stopPolling);

  return {
    startPolling,
    stopPolling,
    pollingEnabled,
  } as Poller;
}
